import { useCallback } from 'react';
import { useGetPromoSocialPostStatsQuery } from '../../../../redux/api/fymAPI';

interface UseSocialPostStatsProps {
  accountId: number;
  /** The id of the post. Undefined while no post is open: the request does not go out. */
  id?: number;
  /** The period in days. The server limits it to the history window of the plan. */
  days: number;
}

/**
 * One post and its daily rows: `GET promo/social-posts/:id/stats?days`. The rows hold running
 * totals, oldest day first.
 */
export function useSocialPostStats({ accountId, id, days }: UseSocialPostStatsProps) {
  const { currentData, isFetching, error, refetch } = useGetPromoSocialPostStatsQuery(
    { accountId, id: id ?? 0, days },
    { skip: id === undefined }
  );

  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);

  return { post: currentData?.post, days: currentData?.days, isLoading: isFetching, error, retry };
}
